import { View, Text, Platform } from "react-native";
import { GuidePageHeader, GuideCard, GuideStep, GuideTip, GuideNav, getGuideNav } from "./_components";

const PAGE_HREF = "/(web)/guide/speurtocht";

export default function SpeurtochtPage() {
  if (Platform.OS !== "web") return null;
  const nav = getGuideNav(PAGE_HREF);

  return (
    <View>
      <GuidePageHeader
        icon="map"
        title="Speurtocht"
        subtitle="Een avontuurlijke scavenger hunt! Volg aanwijzingen, scan QR-codes en ontdek verborgen locaties."
        color="#06B6D4"
      />

      {/* Wat is de speurtocht? */}
      <Text className="text-xl font-bold text-gray-900 mb-4">Wat is de Speurtocht?</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De speurtocht is een interactieve scavenger hunt die door de commissie wordt opgezet. 
        Teams volgen een route met verschillende stappen. Elke stap bevat een uitdaging die 
        je moet voltooien voordat je door kunt naar de volgende.
      </Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De speurtocht is perfect voor tijdens het weekend: het combineert bewegen, samenwerken 
        en puzzelen in één activiteit.
      </Text>

      {/* Soorten stappen */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Soorten Stappen</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De speurtocht bestaat uit verschillende soorten stappen:
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="location"
          title="Locatie"
          description="Ga naar een specifieke locatie. De app controleert via GPS of je er bent. Soms zie je de locatie op een kaart, soms krijg je alleen een aanwijzing."
          color="#10B981"
        />
        <GuideCard
          icon="qr-code"
          title="QR-code scannen"
          description="Zoek en scan een QR-code die ergens is verstopt. De camera opent automatisch wanneer je bij deze stap aankomt."
          color="#3B82F6"
        />
        <GuideCard
          icon="camera"
          title="Foto maken"
          description="Maak een foto die aan de opdracht voldoet. Bijvoorbeeld: 'Maak een foto van je team bij het meer'."
          color="#8B5CF6"
        />
        <GuideCard
          icon="extension-puzzle"
          title="Puzzel"
          description="Los een puzzel of raadsel op. Dit kan een wiskundige puzzel, woordpuzzel of logica-raadsel zijn."
          color="#EC4899"
        />
        <GuideCard
          icon="text"
          title="Woord raden"
          description="Raad een woord of antwoord op een vraag. Typ je antwoord in en de app controleert of het juist is."
          color="#F59E0B"
        />
      </View>

      {/* Hoe speel je de speurtocht? */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Hoe speel je?</Text>

      <View className="mb-6">
        <GuideStep
          step={1}
          title="Speurtocht starten"
          description="Wanneer de commissie een speurtocht activeert, verschijnt deze op je startscherm en in de spellen-tab. Tik om te beginnen."
          color="#06B6D4"
        />
        <GuideStep
          step={2}
          title="Eerste stap lezen"
          description="Lees de instructies van de eerste stap. Je ziet wat je moet doen en eventueel een kaart met de locatie."
          color="#06B6D4"
        />
        <GuideStep
          step={3}
          title="Stap voltooien"
          description="Voltooi de opdracht: ga naar de locatie, scan de QR-code, maak de foto of los de puzzel op."
          color="#06B6D4"
        />
        <GuideStep
          step={4}
          title="Volgende stap"
          description="Na het voltooien van een stap wordt de volgende stap automatisch ontgrendeld. Ga door tot je alle stappen hebt voltooid."
          color="#06B6D4"
        />
        <GuideStep
          step={5}
          title="Speurtocht afronden"
          description="Wanneer alle stappen zijn voltooid, is de speurtocht klaar! Je team ontvangt de verdiende punten."
          color="#06B6D4"
        />
      </View>

      <GuideTip title="Werk samen als team!">
        De speurtocht is een teamactiviteit. Overleg met je teamgenoten over de oplossingen 
        en verdeel de taken. Gebruik de team chat om te coördineren als je niet bij elkaar bent.
      </GuideTip>

      {/* GPS en Camera */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Toestemming nodig</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Voor de speurtocht heeft de app toegang nodig tot:
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="navigate"
          title="Locatie (GPS)"
          description="Om te controleren of je op de juiste locatie bent. De app vraagt om toestemming wanneer dit nodig is."
          color="#10B981"
        />
        <GuideCard
          icon="camera"
          title="Camera"
          description="Voor het scannen van QR-codes en het maken van foto's bij foto-stappen."
          color="#3B82F6"
        />
      </View>

      <GuideTip variant="warning" icon="alert-circle" title="Locatie-instellingen">
        Zorg ervoor dat je locatieservices aan staan op je telefoon. Zonder GPS kan de app 
        niet controleren of je op de juiste plek bent bij locatie-stappen.
      </GuideTip>

      <GuideNav {...nav} />
    </View>
  );
}
